import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { cardService } from '../services/cardService';
import { Card, CardFilters } from '../types';

export function useCards(filters: CardFilters = {}) {
  return useQuery({
    queryKey: ['cards', filters],
    queryFn: () => cardService.list(filters),
    placeholderData: (prev) => prev,
  });
}

export function useCard(id: number) {
  return useQuery({
    queryKey: ['cards', id],
    queryFn: () => cardService.getById(id),
    enabled: !!id,
  });
}

export function useCreateCard() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Card>) => cardService.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cards'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useUpdateCard() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Card> }) => cardService.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cards'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useDeleteCard() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => cardService.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cards'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
      qc.invalidateQueries({ queryKey: ['binders'] });
    },
  });
}
